import i18n from 'i18n';

import * as apiGetSettingKey from 'api/setting/GetSettingV1';
import { fireAlert } from 'functions/fireAlert';
import { restart } from 'functions/tokenFunctions';
import { ReducerBuilder } from 'reducers/ReducerBuilder';
import { payloadReducer } from 'reducers/reducerUtils';

export type AllowedUiLanguageType = string[];

export async function getallowedUiLanguageFromApi(): Promise<AllowedUiLanguageType> {
	const response = await apiGetSettingKey.callApi();
	const result = response.map((x) => x.ui.languages.split(',')).getOrDefault([]);

	if (result.isEmpty()) {
		fireAlert(
			2,
			i18n.t('alerts:ALERT_UI_LANGUAGES_TITLE'),
			i18n.t('alerts:ALERT_UI_LANGUAGES_TEXT')
		);
		restart();
	}

	return result;
}

const rb = new ReducerBuilder<AllowedUiLanguageType>();

export const allowedUiLanguageLoadedAction = rb.createActionForReducer(
	payloadReducer((x) => x),
	'allowedUiLanguage/LoadedFromBackend'
);

export const allowedUiLanguageReducer = rb.createReducer();
